<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import PostSaleManagementDeedRow from './PostSaleManagementDeedRow.vue';
import PostSaleManagementDeedsPagination from './PostSaleManagementDeedsPagination.vue';

defineProps({
  rows: { type: Array, default: () => [] },
  paginatedRows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  page: { type: Number, required: true },
  pageSize: { type: Number, required: true },
  longestSaleDays: { type: Number, default: 0 },
});

const emit = defineEmits(['openCase', 'changePage', 'changePageSize']);
const { t } = useI18n();
</script>

<template>
  <LaisCard
    :title="t('POST_SALE.MANAGEMENT.DEEDS_LONGEST_SALE')"
    density="flush"
  >
    <template #titleAction>
      <PostSaleManagementDeedsPagination
        :page="page"
        :page-size="pageSize"
        :total="rows.length"
        @change-page="emit('changePage', $event)"
        @change-page-size="emit('changePageSize', $event)"
      />
    </template>
    <div class="overflow-x-auto">
      <table class="min-w-[920px] w-full text-sm">
        <thead
          class="bg-lais-bg-soft text-xs font-semibold text-lais-text-muted"
        >
          <tr>
            <th class="px-4 py-3 text-left">
              {{ t('POST_SALE.MANAGEMENT.DEEDS_COLUMNS.RESPONSIBLE') }}
            </th>
            <th class="px-4 py-3 text-left">
              {{ t('POST_SALE.MANAGEMENT.DEEDS_COLUMNS.ADDRESS') }}
            </th>
            <th class="px-4 py-3 text-left">
              {{ t('POST_SALE.MANAGEMENT.DEEDS_COLUMNS.TYPE') }}
            </th>
            <th class="px-4 py-3 text-center">
              {{ t('POST_SALE.MANAGEMENT.DEEDS_COLUMNS.DAYS') }}
            </th>
            <th class="px-4 py-3 text-left">
              {{ t('POST_SALE.MANAGEMENT.DEEDS_COLUMNS.MANAGER') }}
            </th>
            <th class="px-4 py-3">
              <span class="sr-only">
                {{ t('POST_SALE.MANAGEMENT.DEEDS_COLUMNS.ACTIONS') }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="6" class="px-4 py-12 text-center text-lais-text-muted">
              {{ t('POST_SALE.COMMON.LOADING') }}
            </td>
          </tr>
          <template v-else>
            <PostSaleManagementDeedRow
              v-for="row in paginatedRows"
              :key="row.processo_id"
              :row="row"
              @open-case="emit('openCase', $event)"
            />
          </template>
          <tr v-if="!loading && !rows.length">
            <td colspan="6" class="px-4 py-12 text-center text-lais-text-muted">
              {{ t('POST_SALE.EMPTY.DEEDS') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <template #footer>
      <p class="text-sm text-lais-text-muted">
        {{
          t('POST_SALE.MANAGEMENT.DEEDS_LONGEST_DAYS', {
            days: longestSaleDays,
          })
        }}
      </p>
    </template>
  </LaisCard>
</template>
